const r = (e) => e !== !1;
export {
  r as shouldMockBatchAnswer
};
//# sourceMappingURL=ShouldMockBatchAnswer.js.map
